import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/role_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Role',
    column_type: 'string',
    column_name: 'name',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'custom'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
  kind_in: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'custom'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'custom_permissions': { required: false, disabledUpdate: false },
  },
  'custom_permissions': {
    'user': { required: false, disabledUpdate: true },
    'admin_users_role': { required: false, disabledUpdate: true },
    'role': { required: false, disabledUpdate: true },
    'store_owner': { required: false, disabledUpdate: true },
    'merchant': { required: false, disabledUpdate: true },
    'agent': { required: false, disabledUpdate: true },
    'event': { required: false, disabledUpdate: true },
    'red_packet': { required: false, disabledUpdate: true },
    'brand': { required: false, disabledUpdate: true },
    'ticket_event': { required: false, disabledUpdate: true },
    'ticket_kind': { required: false, disabledUpdate: true },
    'tag': { required: false, disabledUpdate: true },
    'ticket_order': { required: false, disabledUpdate: true },
    'ticket': { required: false, disabledUpdate: true },
    'ticket_redeem_batch': { required: false, disabledUpdate: true },
    'walk_heba_reward_rule_item': { required: false, disabledUpdate: true },
    'walk_heba_participation_record': { required: false, disabledUpdate: true },
    'walk_step_record': { required: false, disabledUpdate: true },
    'walk_club': { required: false, disabledUpdate: true },
    'walk_prize': { required: false, disabledUpdate: true },
    'walk_challenge': { required: false, disabledUpdate: true },
    'walk_challenge_participation_record': { required: false, disabledUpdate: true },
    'push_notification_history': { required: false, disabledUpdate: true },
    'page': { required: false, disabledUpdate: true },
    'custom_page': { required: false, disabledUpdate: true },
    'active_storage_blob': { required: false, disabledUpdate: true },
    'feedback': { required: false, disabledUpdate: true },
    'withdrawal_application': { required: false, disabledUpdate: true },
    'user_request': { required: false, disabledUpdate: true },
    'reset_password_application': { required: false, disabledUpdate: true },
    'plutus_entry': { required: false, disabledUpdate: true },
    'setting': { required: false, disabledUpdate: true },
  },
  'custom_permissions.user': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'block': { required: false, disabledUpdate: true },
    'unblock': { required: false, disabledUpdate: true },
    'review': { required: false, disabledUpdate: true },
    'push_notifications': { required: false, disabledUpdate: true },
    'unlock_wallet': { required: false, disabledUpdate: true },
    'reset_password': { required: false, disabledUpdate: true },
    'lock_walk_account': { required: false, disabledUpdate: true },
    'unlock_walk_account': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.admin_users_role': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.role': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.store_owner': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.merchant': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.agent': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
    'push_notifications': { required: false, disabledUpdate: true },
    'unlock_wallet': { required: false, disabledUpdate: true },
    'reset_password': { required: false, disabledUpdate: true },
  },
  'custom_permissions.event': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.red_packet': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'manually_return': { required: false, disabledUpdate: true },
  },
  'custom_permissions.brand': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.ticket_event': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.ticket_kind': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.tag': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.ticket_order': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
  },
  'custom_permissions.ticket': {
    'read': { required: false, disabledUpdate: true },
  },
  'custom_permissions.ticket_redeem_batch': {
    'read': { required: false, disabledUpdate: true },
  },
  'custom_permissions.walk_heba_reward_rule_item': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.walk_heba_participation_record': {
    'read': { required: false, disabledUpdate: true },
  },
  'custom_permissions.walk_step_record': {
    'read': { required: false, disabledUpdate: true },
  },
  'custom_permissions.walk_club': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.walk_prize': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.walk_challenge': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.walk_challenge_participation_record': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.push_notification_history': {
    'read': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.page': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.custom_page': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
    'publish': { required: false, disabledUpdate: true },
  },
  'custom_permissions.active_storage_blob': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.feedback': {
    'read': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
    'resolve': { required: false, disabledUpdate: true },
  },
  'custom_permissions.withdrawal_application': {
    'read': { required: false, disabledUpdate: true },
    'approve': { required: false, disabledUpdate: true },
    'reject': { required: false, disabledUpdate: true },
  },
  'custom_permissions.user_request': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.reset_password_application': {
    'read': { required: false, disabledUpdate: true },
    'approve': { required: false, disabledUpdate: true },
    'reject': { required: false, disabledUpdate: true },
  },
  'custom_permissions.plutus_entry': {
    'read': { required: false, disabledUpdate: true },
  },
  'custom_permissions.setting': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Role', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Role', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
